import { STATES } from 'common/domain/states';
import CreditworthinessFormatter from './creditworthiness.formatter';
import { LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG } from 'loans.module/common/domain/constants.loans';

class CreditWorthinessController {

  constructor($state, $log, LoansUserDataService, LoansOperationsService, $window, loadingMobileService) {
    'ngInject';
    this.state = $state;
    this.log = $log;
    this.loansUserDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.loadingMobileService = loadingMobileService;

    this.userId = this.loansUserDataService._employee.userId;
    this.coachmarkData = LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG;
    this.isMobileApp = $window.innerWidth < 1024;
    this.init();
  }

  $onInit() {
    if (this.isMobileApp) {
      this.initFloatingActionButtons();
    }
  }

  init() {
    this.loadingMobileService.show();
    this.loansOperationsService.getCreditworthiness(this.userId)
      .then(creditworthiness => {
        this.creditworthiness = creditworthiness;
        this.data = new CreditworthinessFormatter(creditworthiness, creditworthiness.simulationWitness).format();
        this.loaded = true;
      }, error => {
        this.log.error('CreditWorthinessController init()', error);
        // TODO: [Manu] eliminado ya que probablemente sea motivo de error en la APP. Ver si en la Web es necesario o con el errorInterceptor es suficiente
        // this.state.go(STATES.ERROR);
      }).finally(() => {
        this.loadingMobileService.hide();
      });
  }

  getClasses() {
    return {
      'responsiveMobile': this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp
    };
  }

  goToNeedALoan() {
    if (this.serviceClosed) {
      return;
    }

    this.state.go(STATES.LOANS.NEED_A_LOAN);
  }

  initFloatingActionButtons() {
    this.floatingActionButtons = [
      {
        literal: 'LOANS.CREDITWORTHINESS.ASK_FOR_LOAN',
        disabled: this.serviceClosed
      }
    ];
  }

  showLoading() {
    return !this.loaded && !this.isMobileApp;
  }
}

export default CreditWorthinessController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthiness.controller.js